import Swiper from "../../../../../vendor/swiper/swiper-bundle.esm.browser";

export default class ProductImagesSwiper {
    constructor($el) {
        this.$el = $el;
        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        var swiper = new Swiper(this.$el, {
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: this.$el.querySelector('[data-product-images-swiper-next]'),
                prevEl: this.$el.querySelector('[data-product-images-swiper-prev]'),
            },
        });
    }
}